module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toast"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "toast-wrap"
  }, [_c('div', [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.success),
      expression: "success"
    }],
    staticClass: "icon"
  }, [_vm._v("")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fail),
      expression: "fail"
    }],
    staticClass: "icon"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n        " + _vm._s(_vm.toastMsg) + "\n      ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dff3ab0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast.vue
// module id = 860
// module chunks = 1